import { GridComponent, ColumnModel } from '@syncfusion/ej2-angular-grids';

export interface GridCleanupOptions {
  clearTemplates?: boolean;      // default true
  clearBase64Images?: boolean;   // default false
}

export function destroySyncfusionGrid(grid: GridComponent, opts: GridCleanupOptions = {}) {
  const { clearTemplates = true, clearBase64Images = false } = opts;
  try {
    grid.dataSource = [];
    if (clearTemplates && Array.isArray(grid.columns)) {
      (grid.columns as ColumnModel[]).forEach((c: any) => {
        delete c.template; delete c.headerTemplate; delete c.editTemplate;
      });
    }
    grid.destroy?.();
  } catch {}
  if (clearBase64Images && (grid as any).element) {
    (grid as any).element
      .querySelectorAll('img[src^="data:image"]')
      .forEach((img: HTMLImageElement) => (img.src = ''));
  }
}